// extracted by mini-css-extract-plugin
module.exports = {"columnsWrap":"style__columnsWrap___1qEOJ"};